/**
 * @module Passage
 */
'use strict';

var Route = require('./lib/route');


module.exports = Route;


//////////////////
// WEBPACK FOOTER
// ./node_modules/route-parser/index.js
// module id = 3191
// module chunks = 0